import { useLocation, useNavigate } from "react-router-dom";

function ReservationPending() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  return (
    <div className="min-h-screen bg-[#F7F7F5] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 max-w-md w-full text-center">

        {/* Icône */}
        <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-6 text-3xl">
          📧
        </div>

        <h1 className="text-xl font-bold text-gray-900 mb-2">
          Vérifiez votre email
        </h1>

        <p className="text-sm text-gray-500 leading-relaxed">
          Un lien de confirmation a été envoyé à votre adresse. Cliquez dessus pour finaliser votre réservation.
        </p>

        {email && (
          <div className="mt-4 px-4 py-2.5 bg-gray-50 rounded-xl">
            <p className="text-sm text-gray-700 font-medium">{email}</p>
          </div>
        )}

        <p className="text-xs text-gray-400 mt-3">
          Ce lien expire dans 60 minutes.
        </p>

        <button
          onClick={() => navigate("/")}
          className="mt-8 w-full py-3 rounded-xl bg-[#3A9D23] text-white font-semibold text-sm hover:bg-[#33891E] transition"
        >
          Retour à l'accueil
        </button>

      </div>
    </div>
  );
}

export default ReservationPending;
